import { IconArrowLeft, IconPlayerPlay, IconSparkles, IconTrophy } from "@tabler/icons-react";
import { FLIGHT_ART } from "./flight-art.js";
import "./flight-result.css";

/** @param {{ result: { state: { score: number }, practice?: boolean, pickups: number, milestoneReward: number }, personalBest: number, isNewRecord: boolean, emoji: string, busy: boolean, onRetry: () => void, onRanking: () => void, onBack: () => void }} props */
export function FlightResult({ result, personalBest, isNewRecord, emoji, busy, onRetry, onRanking, onBack }) {
  return <article className="nf-result" aria-labelledby="nf-result-title">
    <div className="nf-result-art" aria-hidden="true">
      <img className="nf-result-castle" src={FLIGHT_ART.panorama} alt="" />
      <img className="nf-result-witch" src={FLIGHT_ART.witch} alt="" />
      <img className="nf-result-pumpkin" src={FLIGHT_ART.pumpkin} alt="" />
      <span className="nf-result-sparks">✦</span>
    </div>
    <div className="nf-result-body">
      <span className="nf-result-eyebrow">Ночной полёт · Хэллоуин</span>
      <h2 id="nf-result-title">{result.practice ? "Тренировка завершена" : "Полёт завершён"}</h2>
      <div className="nf-result-score"><strong>{result.state.score}</strong><span>очков за полёт</span></div>
      {!result.practice && <p className="nf-result-best"><IconTrophy aria-hidden="true" />Рекорд недели <b>{personalBest}</b></p>}
      {!result.practice && isNewRecord && <p className="nf-new-record"><IconSparkles aria-hidden="true" />Новый личный рекорд!</p>}
      {result.practice ? <p className="nf-result-practice">Полетай в турнире, чтобы собирать тыквы<br />и побороться за место в рейтинге.</p> :
        <div className="nf-result-rewards" aria-label="Награды за полёт">
          <div><span>Подборы</span><b>+{result.pickups} <span>{emoji}</span></b></div>
          <div><span>Пороги рекорда</span><b>+{result.milestoneReward} <span>{emoji}</span></b></div>
        </div>}
      <div className="nf-result-actions">
        <button type="button" className="nf-primary" disabled={busy} onClick={onRetry}><IconPlayerPlay aria-hidden="true" />Ещё раз</button>
        <button type="button" className="nf-secondary" onClick={onRanking}><IconTrophy aria-hidden="true" />Рейтинг</button>
        <button type="button" className="nf-text-button" onClick={onBack}><IconArrowLeft aria-hidden="true" />К полёту</button>
      </div>
    </div>
  </article>;
}
